import { useMutation } from "@apollo/client";
import { constantsData, statusTypesData, urlsData } from "data";
import { createUserMutation } from "graph";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useCreateUser = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [createUserAction, { loading }] = useMutation(createUserMutation);

    const createUser = async ({
        email,
        familyName,
        givenName,
        role,
    }) => {
        try {
            await createUserAction({
                onCompleted: () => {
                    navigate(urlsData.routes.users.url);

                    dispatch(openAlert(
                        `${t(
                            "messages.createMsgs.success",
                            { entity: t("users.entity") },
                        )}, ${t("messages.operationDelay")}`,
                        statusTypesData.success,
                    ));
                },
                variables: {
                    data: {
                        email,
                        family_name: familyName, //eslint-disable-line
                        given_name: givenName, //eslint-disable-line
                        role_id: role, //eslint-disable-line
                    },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        createUser,
        loading,
    };
};

export default useCreateUser;
